import { useParams } from "react-router-dom";
import axios from "axios";
import Api from "../../Api/Api.json";
import React, { useState, useEffect } from "react";
import { ArrowBack } from "@mui/icons-material";

const Medicine = ({ test_date, test_id, patient_id, onBack }) => {
	const [htmlString, setHtmlString] = useState("");

	useEffect(() => {
		const headers = { headers: { "Content-Type": "application/json" } };
		const url = Api.PATIENT_API;
		const requestData = {
			task: "getPrescriptionHtmlString",
			patient_id: patient_id,
			test_date: test_date,
			test_id: test_id,
			table_name: "MEDICINEPRECRIBEDTABLE",
		};
		//console.log(requestData);
		axios
			.post(url, requestData, headers)
			.then((response) => {
				console.log(response.data);
				if (response.data.length > 0) {
					//htmlString+=response.data
					setHtmlString(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}, [test_date, test_id, patient_id]);

	//{'task': 'getPatientTestDataFromID', 'patient_id': '130', 'test_date': '2023-07-29 00:00:00', 'test_id': '85721', 'table_name': 'MEDICINEPRECRIBEDTABLE'}
	//const htmlString = '<h2>Coming Soon!</h2><p>Content coming Soon!</p>';
	/*
  var htmlString='<b>Medicine:</b><br><table align="center" style="font-family: Tahoma, Arial, Helvetica, sans-serif; float:left; width:100%; height:auto; margin:0; border-collapse: collapse; padding:0;"><tr>'
  htmlString+='<td style="width:10%; border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">SL</td>'
  htmlString+='<td style="width:40%; border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Name</td>'
  htmlString+='<td style="width:10%; border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Strength</td>'
  htmlString+='<td style="width:20%; border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Dosage</td>'
  htmlString+='<td style="width:10%; border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Time</td>'
  htmlString+='<td style="width:10%; border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Continue Till</td>'
  htmlString+='</tr></table>';
  */

	const renderHTML = (htmlString) => {
		//const styledHtmlString = `<div style="color: white;">${htmlString}</div>`;
		return { __html: htmlString };
		//return { __html: styledHtmlString };
	};

	return (
		<div
			className="flex flex-col justify-between"
			style={{
				minHeight: "calc(100vh - 247px)",
			}}
		>
			<div>
				<h1>Item Details</h1>
				<p>Item Name: {test_date + "," + test_id}</p>
				<div className="html-report-container pt-2">
					<div dangerouslySetInnerHTML={renderHTML(htmlString)} />
				</div>
			</div>
			<div>
				<button
					className="btn btn-primary flex flex-row items-center gap-2 !text-base"
					onClick={onBack}
				>
					<ArrowBack fontSize="small" />
					Back
				</button>
			</div>
		</div>
	);
};

export default Medicine;
